import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../../../api";
import { AxiosError } from "axios";

export function useAttendanceLocalDepartmentQueueServiceTimeComplementExceptionDelete() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    return useMutation<
        void,
        AxiosError<{ detail: string }>,
        number // id da exceção a ser removida
    >({
        mutationKey: ["attendance-local", "department", "queue", "service-time-complement-exception", "delete"],
        mutationFn: async (id: number) => {
            await apisiseci.delete(`/cms/excecao_horario_agendamento_complementar/${id}/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time-complement-exception', 'list']
            });
            toast.success("Exceção de tempo de serviço complementar removida com sucesso!");
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
        },
    });
}
